import { colors } from "healthex-common/colors";
import { fontWeights } from "healthex-common/weights";
import styled, { css } from "styled-components";
import { AdminFormSection } from "./AdminFormShared.styles";
import { HXCheckbox } from "./base.styles";
import { FlexColumnDiv } from "./common.styles";
export const CheckboxBold = styled(HXCheckbox) `
    .MuiFormControlLabel-label {
        font-weight: ${fontWeights.BOLD};
    }
`;
export const AdminLoginSettingsViewParent = styled(FlexColumnDiv) `
    gap: 32px;
`;
export const SSOFormSection = styled(AdminFormSection) `
    margin-left: 42px;

    ${(props) => props.disabled &&
    css `
            color: ${colors.black_30};
        `}
`;
